import { render, staticRenderFns } from "./editInsuranceReqRCA.vue?vue&type=template&id=a866143c&"
import script from "./editInsuranceReqRCA.js?vue&type=script&lang=js&"
export * from "./editInsuranceReqRCA.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports